import { Text, TextArea } from "./styles";

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(e: React.ChangeEvent<HTMLTextAreaElement>) => void} props.onChange
 * @param {string} [props.placeholder]
 * @param {boolean} [props.readOnly]
 * @param {string} [props.fontSize]
 * @param {string} [props.fontWeight]
 * @param {string} [props.minHeight]
 * @returns
 */
export default function TextAreaInput({ readOnly = false, ...props }) {
  return !readOnly ? (
    <TextArea
      value={props.value}
      placeholder={props?.placeholder}
      fontSize={props?.fontSize}
      fontWeight={props?.fontWeight}
      minHeight={props?.minHeight}
      onChange={props.onChange}
    />
  ) : (
    <Text fontSize={props?.fontSize} fontWeight={props?.fontWeight}>
      {props?.value ? props.value : props?.placeholder}
    </Text>
  );
}
